import { FetcherResult } from "../api-client/fetcher";
import { PostResponse, usePost } from "../api-client/usePost";
import { useCartNext } from "../stores/hooks/useCartNext";
import { useDealerAccountInfo } from "../stores/hooks/useDealerAccountInfo";
import {
  AnyOrderItem,
  OptionalLineItem,
  OrderDetails,
} from "../stores/slices/cartSlice";
import { useGetNewCart } from "./useGetNewCart";

type AddLineItemToCart = (
  orderItem: Pick<AnyOrderItem, "orderItemId">,
  lineItem: Pick<OptionalLineItem, "lineItemId" | "price">,
  priceMatchOptions?: {
    lineItemNotes: string;
    lineItemPrice: string;
    lineItemWorkOrderNumber: string;
  }
) => Promise<FetcherResult<OrderDetails>>;

export const useAddLineItemToCart = (): Omit<
  PostResponse<OrderDetails>,
  "send"
> & {
  send: AddLineItemToCart;
} => {
  const init = useGetNewCart();
  const { send: addLineItemToCart, ...post } = usePost<OrderDetails>(
    "/retailSiteWebService/shopping/cart/addLineItemToCart.php"
  );
  const { dealerId } = useDealerAccountInfo();
  const cartNext = useCartNext();
  const send: AddLineItemToCart = async (
    { orderItemId },
    { lineItemId, price },
    priceMatchOptions
  ) => {
    const { orderNumber } = await init();
    const response = await addLineItemToCart({
      cartId: orderNumber,
      cartItemId: orderItemId,
      dealerId,
      lineItemId,
      lineItemNotes: priceMatchOptions?.lineItemNotes ?? "",
      lineItemPrice: priceMatchOptions?.lineItemPrice ?? price,
      lineItemWorkOrderNumber: priceMatchOptions?.lineItemWorkOrderNumber ?? "",
      orderNumber,
    });
    cartNext(response.payload);
    return response;
  };
  return { ...post, send };
};
